import { Link } from 'react-router-dom';
import { CATEGORIES } from '../../lib/constants';
import { ArrowUpRight } from 'lucide-react';
import { useSiteImage } from '../../lib/useSiteImage';

const categoryImageKey = (key) => `category_${key.replace(/-/g, '_')}`;

const CategoryCard = ({ c, i, className }) => {
  const img = useSiteImage(categoryImageKey(c.key), c.image);
  return (
    <Link
      to={`/artists?occasions=${encodeURIComponent(c.title)}`}
      data-testid={`category-card-${c.key}`}
      className={`group relative img-zoom block ${className}`}
    >
      <img src={img} alt={c.title} className="w-full h-full object-cover" loading="lazy" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
      <div className="absolute inset-0 p-5 flex flex-col justify-between text-white">
        <div className="flex items-center justify-between">
          <span className="text-[10px] uppercase tracking-[0.3em] opacity-80">0{i + 1}</span>
          <ArrowUpRight className="w-5 h-5 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
        </div>
        <div>
          <div className="text-[10px] uppercase tracking-[0.3em] opacity-80">{c.sub}</div>
          <div className="font-serif text-2xl md:text-3xl leading-tight mt-1">{c.title}</div>
        </div>
      </div>
    </Link>
  );
};

export const Categories = () => {
  return (
    <section className="bg-white py-24 md:py-32" data-testid="categories-section">
      <div className="container-edge">
        <div className="grid md:grid-cols-12 gap-8 items-end mb-14">
          <div className="md:col-span-7">
            <div className="text-[11px] uppercase tracking-[0.3em] text-[#eb5381]">Browse By Style</div>
            <h2 className="mt-3 font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
              Every <span className="italic text-[#a465a8]">occasion,</span> every aesthetic.
            </h2>
          </div>
          <div className="md:col-span-5">
            <p className="text-neutral-700 text-base md:text-lg max-w-md leading-relaxed">
              From soft-glam bridal mornings to statement reception nights — discover artists curated for every chapter of your story.
            </p>
          </div>
        </div>

        {/* Layout designed for exactly 7 cards with no empty cells.
            - Mobile (cols=2): first card full-width banner, remaining 6 in 2×3 grid = 7 ✓
            - lg (cols=4): first card tall (row-span-2), remaining 6 in 3×2 grid = 4×2 = 8 cells (1×2 + 6×1) ✓ */}
        <div className="grid grid-cols-2 lg:grid-cols-4 auto-rows-fr gap-3 md:gap-5">
          {CATEGORIES.map((c, i) => (
            <CategoryCard
              key={c.key}
              c={c}
              i={i}
              className={
                i === 0
                  ? 'col-span-2 lg:col-span-1 lg:row-span-2 aspect-[16/10] lg:aspect-auto'
                  : 'aspect-[4/5]'
              }
            />
          ))}
        </div>
      </div>
    </section>
  );
};
